export function roundToFirstDecimalPlace(num: number): number {
    return Math.floor(num * 10) / 10;
}